import { get, post, put, del, BASE_URL as BACKEND_URL } from "../../utils/axiosInstance";
import { getToken } from "../../utils/AuthService";

const BASE_URL = "/rest/inventory";

// --------------------------------------------------------------------------
// INVENTORIES
// --------------------------------------------------------------------------
export const fetchInventory = (id) => {
  const url = `${BASE_URL}/inventory/${id}/`;
  return get(url);
};

export const deleteInventory = (id, data) => {
  const url = `${BASE_URL}/inventory/${id}/delete/`;
  return post(url, data);
};

export const updateInventory = (id, data) => {
  const url = `${BASE_URL}/inventory/${id}/`;
  return put(url, data);
};

export const createTemperature = (data) => {
  const url = `${BASE_URL}/temperature/`;
  return post(url, data);
};

export const createInventories = (data) => {
  const url = `${BASE_URL}/inventory/`;
  return post(url, data);
};

// --------------------------------------------------------------------------
// ITEMS
// --------------------------------------------------------------------------
export const fetchItems = (name, station = null, page = 1) => {
  const url = `${BASE_URL}/item/`;
  let params = {
    page: page,
  };
  if (name) params.name = name;
  if (station) params.station = station;
  return get(url, { params });
};

export const getItems = (name, inventory, items = null, station = null, vendorId = null, includeNonPlantItems = null) => {
  const url = `${BASE_URL}/item/`;
  let params = {};
  if (name) params.name = name;
  if (inventory) params.not_inventory = inventory;
  if (items) params.items = items;
  if (station) params.station = station;
  if (vendorId) params.vendor_id = vendorId;
  if (includeNonPlantItems) params.include_non_plant_items = includeNonPlantItems;
  return get(url, { params: params });
};

export const getItem = (item_id) => {
  const url = `${BASE_URL}/item/${item_id}`;
  return get(url);
};

export const fetchMarketItems = (name, station = null, page = 1) => {
  const url = `${BASE_URL}/market_items/`;
  let params = {
    page: page,
  };
  if (name) params.name = name;
  if (station) params.station = station;
  return get(url, { params });
};

export const getItemFromInventory = (inventoryId) => {
  const url = `${BASE_URL}/inventory/${inventoryId}/get_item/`;
  return get(url);
};

export const fetchInventoriesRecall = (page, inventory_id = null, session_id = null, lot_id = null, shipment_id = null, plant_id = null, vendor = null) => {
  let url = `${BASE_URL}/inventory/inventory_recall/?page=${page}`;
  if (inventory_id) url += `&inventory_id=${inventory_id}`;
  if (session_id) url += `&session_id=${session_id}`;
  if (lot_id) url += `&lot_id=${lot_id}`;
  if (shipment_id) url += `&shipment_id=${shipment_id}`;
  if (plant_id) url += `&plant_id=${plant_id}`;
  if (vendor) url += `&vendor=${vendor}`;
  return get(url);
};

export const fetchInventoriesRecallCSV = (filters) => {
  let url = `${BASE_URL}/inventory/export_inventory_recall_csv/?`;
  if (filters.inventoryID) url += `&inventory_id=${filters.inventoryID}`;
  if (filters.sessionID) url += `&session_id=${filters.sessionID}`;
  if (filters.lotID) url += `&lot_id=${filters.lotID}`;
  if (filters.shipmentID) url += `&shipment_id=${filters.shipmentID}`;
  if (filters.plantID) url += `&plant_id=${filters.plantID}`;
  if (filters.vendor) url += `&vendor=${filters.vendor}`;
  return get(url, { responseType: "arraybuffer" });
};

// --------------------------------------------------------------------------
// BRANDS
// --------------------------------------------------------------------------
export const fetchBrands = (vendorBrands = null, priceLists = null) => {
  const url = `${BASE_URL}/brand/`;
  if (vendorBrands) {
    return get(url, { params: { vendor_brands: true, price_lists: priceLists } });
  }
  return get(url);
};

// --------------------------------------------------------------------------
// ITEM OFFERS BY PRICE
// --------------------------------------------------------------------------
export const fetchItemOffers = (id) => {
  const url = `${BASE_URL}/item/${id}/offers/`;
  return get(url);
};

// --------------------------------------------------------------------------
// GRADES
// --------------------------------------------------------------------------
export const fetchGrades = () => {
  const url = `${BASE_URL}/grade/`;
  return get(url);
};

// --------------------------------------------------------------------------
// WASTE CATEGORIES
// --------------------------------------------------------------------------
export const fetchWasteCategories = () => {
  const url = `${BASE_URL}/waste_category/`;
  return get(url);
};

// --------------------------------------------------------------------------
// LOCATIONS
// --------------------------------------------------------------------------
export const fetchLocations = () => {
  const url = `${BASE_URL}/location/`;
  return get(url);
};

export const updateInventoriesLocation = (data) => {
  const url = `${BASE_URL}/inventory/update_inventories_location/`;
  return post(url, data);
};

// --------------------------------------------------------------------------
// INVENTORY AUDITS
// --------------------------------------------------------------------------
export const fetchAudits = (page) => {
  const url = `${BASE_URL}/audit/?page=${page}`;
  return get(url);
};

export const createAudit = (data) => {
  const url = `${BASE_URL}/audit/`;
  return post(url, data);
};

export const fetchAudit = (id) => {
  const url = `${BASE_URL}/audit/${id}/`;
  return get(url);
};

export const getInventory = (iId, active, sId) => {
  const url = `${BASE_URL}/inventory/${iId}/by-range/`;
  // Hack for backwards compatibility with old labels
  const oldLabelFormat = /http:\/\/inventory:8082\/Inventory2\/Action_Pages\/QrScanPage.php?[\W\w]*uniqueid=(\d+)[\W\w]*/;
  if (oldLabelFormat.test(iId)) iId = oldLabelFormat.exec(iId)[1];
  return get(url, { params: { active: active, session: sId } });
};

export const addAuditInventory = (data) => {
  const url = `${BASE_URL}/audit/${data.audit}/items/`;
  return post(url, data);
};

export const removeAuditInventory = (data) => {
  const url = `${BASE_URL}/audit/${data.audit}/items/${data.id}`;
  return del(url);
};

export const finishInventoryAudit = (id) => {
  const url = `${BASE_URL}/audit/${id}/finish/`;
  return post(url);
};

export const csvSubmit = (data) => {
  const url = `${BASE_URL}/deactivate/`;
  let form_data = new FormData();
  form_data.append("items_to_deactivate", data, `to_deactivate_${new Date().toISOString().slice(0, 10)}.csv`);
  return post(url, form_data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const fetchInventoryAuditXLS = (id) => {
  const url = `${BASE_URL}/audit/${id}/export_audit_results/`;
  return get(url, { responseType: "arraybuffer" });
};

export const fetchInventoryR365AuditXLS = (id) => {
  const url = `${BASE_URL}/audit/${id}/export_audit_r365_results/`;
  return get(url, { responseType: "arraybuffer" });
};

// In this request we had to replace the axios .post method with vanilla fetch code.
// This was needed because the excel file returned from the backend in this request was being corrupted because of headers set by axios
export const fetchInventoryR365AuditXLSJoined = async (id, data) => {
  const url = `${BACKEND_URL}${BASE_URL}/audit/${id}/export_audit_r365_joined/`;
  let form_data = new FormData();
  form_data.append("r365_report", data.file);

  try {
    const token = getToken();
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    });
    return await response.blob();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getInventoryToAudit = (id, code) => {
  let url = `${BASE_URL}/audit/${id}/inventory_from_code/`;
  let params = {};
  if (code) params.code = code;
  return get(url, { params: params });
};

// --------------------------------------------------------------------------
// UTILS
// --------------------------------------------------------------------------
export const fetchUnitConstants = () => {
  const url = `${BASE_URL}/unit_constants/`;
  return get(url);
};
